import type { IScheda } from '../models';

export interface ISchedaStep {
  value: number;
  label: string;
}

// Gli ID restano stabili; stato dell'intervento e ambienti decidono la sequenza.
export const getSchedaSteps = (scheda: IScheda): ISchedaStep[] => {
  const statoIntervento: string = scheda.statoIntervento.trim().toLowerCase();
  const showAll: boolean = ['nuova abitazione', 'ristrutturazione totale'].includes(statoIntervento);
  const selectedTypes: string[] = (scheda.ambienti ?? [])
    .filter((ambiente) => true === ambiente.coinvolto)
    .map((ambiente) => ambiente.tipo.trim().toLowerCase());
  const hasOutdoor: boolean = selectedTypes.some((tipo) => ['terrazzo', 'esterno', 'esterni'].includes(tipo));
  const hasBedroom: boolean = selectedTypes.some((tipo) => ['camera', 'camera da letto'].includes(tipo));
  return [
    { value: 1, label: 'Sintesi' },
    { value: 2, label: 'Ambienti' },
    ...(showAll ? [{ value: 3, label: 'Luce' }] : []),
    { value: 4, label: 'Strutture e Impianti Esistenti' },
    ...(showAll || hasOutdoor ? [{ value: 5, label: 'Esterni' }] : []),
    ...(showAll || hasBedroom ? [{ value: 6, label: 'Contesto' }] : []),
    { value: 7, label: 'Vincoli' },
    { value: 8, label: 'Priorità' },
  ];
};
